import callApi, { BaseResponseDto } from "./baseRequest";

const route = 'customers-survey-configuration';

export interface SaveRequest extends GetResponse {}

export interface GetResponse {
    monthsActive: Array<number>,
    displayQuantity: number
}

export function get(): Promise<BaseResponseDto<GetResponse>> {
    const result: BaseResponseDto<GetResponse> = {
        error: '',
        data: {} as GetResponse,
        success: false
    };

    const response = callApi('GET', `${route}`)
        .then(resp => {
            if (resp?.error == null ?? false) {
                result.success = true;
                result.data = resp?.data;
            }
            else {
                result.error = result.error
            }
            return result;
        })
        .catch(err => {
            result.error = err.error;

            return result;
        })

    return response;
};

export function save(body: SaveRequest): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        data: null,
        success: false
    };

    const response = callApi('POST', `${route}`, body)
    .then(resp => {
        if (resp?.error == null ?? false) {
            result.success = true;
        }
        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};